import React, { useEffect, useRef } from "react";
import { Outlet } from "react-router-dom";
import Header from "../../landingPage/Header";
import Footer from "../../landingPage/Footer";
import ContactForm from "../../landingPage/ContactForm";
import SliderRating from "../../landingPage/SliderRating";
// import OlympiadExams from "../OlympiadExams";
// import { Button } from "../../../components";

const LoginLayout = () => {
  // const navigate = useNavigate();
  const contactFormRef = useRef(null);
  const setFormRef = (ref) => {
    contactFormRef.current = ref;
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Header placement="register" />
      <section className="school-registration sign-in-account pt-24 lg:pt-0">
        <div className="m-10">
          <div className="container-fluid flex justify-center">
            <div className="col-md-12 col-lg-6 left-item">
              <Outlet />
            </div>
          </div>
        </div>
      </section>
      {/* <OlympiadExams /> */}
      <SliderRating contactFormRef={contactFormRef} />
      <ContactForm contactFormRef={setFormRef} />
      <Footer />
    </div>
  );
};

export default LoginLayout;
